export default __webpack_public_path__ + "static/media/profile-wallet-icon.f89fd5fc.svg";